export default __webpack_public_path__ + "static/media/back.ffe45b82.png";